import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=d1820a56"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=d1820a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports